//@flow
import * as actionTypes from './actionTypes';
import * as workerApis from '@lesofi/phoenix-sdk-js/lib/phoenixgoapi/worker'
import * as oldApi from '../../apiUtils/api';

export const getTaskCategories=(jwt:any)=>{
    return (dispatch:any) => workerApis.getTaskCategoriesApi(jwt,1,1000,"title","asc",null)
    .then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.TASK_REDUCER_COMMON_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.GET_TASK_CATEGORIES, taskCategories: data['results'] });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.TASK_REDUCER_COMMON_ERROR, error: err});
    })
}

export const selectTaskCategory=(taskCategory:any)=>{
    return { 
        type: actionTypes.SELECT_TASK_CATEGORY, 
        taskCategoryId: taskCategory.id,
        tasks: taskCategory.taskDists
    };
}

export const tasksListUIAcknowledge=()=>{
    return { type: actionTypes.TASKS_LIST_UI_ACK };
}

export const refreshTasksList=(jwt:any,taskCategoryId:any)=>{
    return (dispatch:any) => workerApis.getTaskWorkflowsByCategoryIdApi(jwt,taskCategoryId,1,1000,"task_order","asc").then((res)=>res.json()).then((data) =>{
        if (data.error){
            dispatch({type: actionTypes.TASK_REDUCER_COMMON_ERROR,error: data.error});
        }else {
            dispatch({type: actionTypes.REFRESH_TASKS_LIST, tasks: data['results'], taskCategoryId: taskCategoryId });
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.TASK_REDUCER_COMMON_ERROR, error: err});
    })
}

export const acceptTask=(jwt:any,taskId: any)=> {
    return (dispatch:any) => oldApi.acceptTask(jwt,taskId).
    then(res => res.json()).then(data => {
        if (data && data.error){
            dispatch({type: actionTypes.TASK_ACCEPT_ERROR, error: data.error});
        }else {
            if (data){
                dispatch({ type: actionTypes.TASK_ACCEPT, taskAcceptedInfo: data.taskAcceptedInfo});
            }
        }
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.TASK_ACCEPT_ERROR, error: err});
    })
}

export const checkResumeTaskInfo=(jwt:any,taskId: any)=>{
    return (dispatch:any) => oldApi.getResumeTaskInfo(jwt,taskId).
    then((res)=>res.json()).then(data => {
        if (data && data.error) {
            dispatch({type: actionTypes.TASK_REDUCER_COMMON_ERROR, error: data.error});
        }else {
            if (data) {
                dispatch({ type: actionTypes.TASK_CAN_RESUME, taskAcceptedInfo: data.taskAcceptedWorker});
            }
        }   
    }).catch((err)=>{
        console.log(err);
        dispatch({type: actionTypes.TASK_REDUCER_COMMON_ERROR, error: err});
    })
}

export function taskSelect(task:any){
    return { type: actionTypes.TASK_SELECT, task};
}

export function taskCancel(){
    return { type: actionTypes.TASK_CANCEL};
}

export function taskAccept(taskAcceptedInfo:any){
    return { type: actionTypes.TASK_ACCEPT, taskAcceptedInfo};
}

export function taskAcceptError(error:any){
    return { type: actionTypes.TASK_ACCEPT_ERROR, error};
}

export function taskCompleted(){
    return { type: actionTypes.TASK_COMPLETED };
}

export function taskCanResume(taskAcceptedInfo:any){
    return { type: actionTypes.TASK_CAN_RESUME, taskAcceptedInfo};
}

export function taskAcceptResume(taskAcceptedInfo:any){
    return { type: actionTypes.TASK_ACCEPT_RESUME, taskAcceptedInfo};
}

export const taskSelected=()=>{
    return { type: actionTypes.TASK_SELECTED };
}

export const setWaiting=(status:boolean)=>{
    return { type: actionTypes.SET_WAITING, status };
}


// WEBPACK FOOTER //
// ./src/redux/tasks/actions.js